import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createProviderIntegration } from "../../../redux/actions/integrationsActions";
import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import { clouds } from "../../../utils/icons";
import PdForm from "./pdForm";
import { PROVIDERS } from "../../../consts/general";
import "./pagerDutyProviderIntegration.scss";

const PagerDutyProviderIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const isDarkTheme = useSelector(
    (state) => state.userPreferencesReducer.themeDark
  );

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "Setup PagerDuty Integration",
      content_title: "PagerDuty Provider Integration",
      content: (
        <PdForm
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);
        const req = await dispatch(
          createProviderIntegration("pagerduty-provider", {
            name: wizardState?.name,
            authtoken: wizardState?.authtoken,
            usertoken: wizardState?.usertoken,
          })
        );
        setLoadingSubmit(false);
        if (!req?.ok) {
          throw new Error(`Failed to create PagerDuty integration.`);
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
          subTitle="The Resources from the Integration will take up to one hour to appear in the inventory"
          doesTakeTime
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="PagerDutyProviderIntegration">
      <AppWizard
        iconSrc={clouds(PROVIDERS.pagerduty, isDarkTheme)}
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
      />
    </div>
  );
};

export default PagerDutyProviderIntegration;
